export const getClasseResiduos = (state) => state.classeResiduos.lista
export const getIsCarregandoListaClasseResiduos = (state) => state.classeResiduos.isCarregandoLista
